import { render } from "./UploadJson.vue?vue&type=template&id=5c9e1886&ts=true"
import script from "./UploadJson.vue?vue&type=script&lang=ts"
export * from "./UploadJson.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__